import { render, staticRenderFns } from "./ProjectJournalTable.vue?vue&type=template&id=bc7821b0&scoped=true&"
import script from "./ProjectJournalTable.vue?vue&type=script&lang=js&"
export * from "./ProjectJournalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7821b0",
  null
  
)

export default component.exports